import { Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface ReviewConfig {
  imageSrc: string;
  imageAlt?: string;
  text: string;
  personName?: string;
  personPosition?: string;
  imageWidth?: number;
  imageHeight?: number;
  logo?: {
    src: string;
    alt?: string;
    width?: number;
    height?: number;
  }
}

@Component({
  selector: 'app-review',
  imports: [NgOptimizedImage, TranslateModule],
  templateUrl: './review.component.html',
  styleUrl: './review.component.scss'
})
export class ReviewComponent {
  config = input.required<ReviewConfig>();
}
